"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asFormalDate = void 0;

var _date = require("../type-checks/date");

var asFormalDate = function asFormalDate(input) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "en-us";
  var config = arguments.length > 2 ? arguments[2] : undefined;
  // Let formal date be input;
  var formalDate = input; // Let default date time format config be extended;

  var dateTimeFormatConfig = Object.assign({
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    timeZoneName: "short"
  }, config); // If formal date is not a date;

  if (!(0, _date.isDate)(formalDate)) {
    // Convert it to a date;
    formalDate = new Date(input);
  } // If formal date is date;


  if ((0, _date.isDate)(formalDate)) {
    // Set formal date using Intl DateTimeFormat API;
    formalDate = new Intl.DateTimeFormat(locale, dateTimeFormatConfig).format(formalDate);
  } else {
    // Restore formal date to input;
    formalDate = input;
  } // Return formal date;


  return formalDate;
};

exports.asFormalDate = asFormalDate;